export default __webpack_public_path__ + "static/media/shift.5468a45d.wav";